var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_1777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4.575C23.1 4.95 22.2 5.25 21.15 5.325C22.2 4.725 22.95 3.75 23.325 2.625C22.35 3.225 21.3 3.6 20.175 3.825C19.275 2.85 18 2.25 16.65 2.25C13.95 2.25 11.7 4.425 11.7 7.2C11.7 7.575 11.775 7.95 11.85 8.325C7.72502 8.1 4.12502 6.15 1.65002 3.15C1.20002 3.9 0.975018 4.725 0.975018 5.625C0.975018 7.35 1.87502 8.85 3.15002 9.75C2.32502 9.75 1.57502 9.525 0.900018 9.15V9.225C0.900018 11.625 2.62502 13.575 4.87502 14.025C4.42502 14.1 4.05002 14.175 3.60002 14.175C3.30002 14.175 3.00002 14.175 2.70002 14.1C3.30002 16.05 5.17502 17.475 7.27502 17.55C5.62502 18.9 3.45002 19.65 1.12502 19.65C0.750018 19.65 0.300018 19.65 -0.0749817 19.575C2.17502 20.925 4.80002 21.75 7.57502 21.75C16.65 21.75 21.6 14.25 21.6 7.725C21.6 7.5 21.6 7.275 21.6 7.125C22.5 6.375 23.325 5.55 24 4.575Z",
    fill: "#C9FFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_1777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTwitter);
export default __webpack_public_path__ + "static/media/logo-twitter.3f9edac88e8a6050585457081bf1ac43.svg";
export { ForwardRef as ReactComponent };